import { useSites } from '../../lib/useSites';
import { TOUS_LES_SITES } from '../../site/context';
import { usePerimetre } from '../../site/usePerimetre';

/**
 * Barre de sélection du périmètre, reprise du helper `siteBar` de la maquette.
 * N'apparaît que si l'utilisateur a plus d'une antenne : un(e) assistant(e)
 * pédagogique de site n'a rien à sélectionner (CDC §2.3, §6.1).
 */
export function BarreSites(): JSX.Element | null {
  const { data } = useSites();
  const { site, definirSite } = usePerimetre();

  const sites = data?.sites ?? [];
  if (sites.length <= 1) return null;

  const options = [{ code: TOUS_LES_SITES, libelle: 'Tous les sites' }].concat(
    sites.map((item) => ({ code: item.code, libelle: item.code })),
  );

  return (
    <div role="group" aria-label="Antennes affichées" className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white p-1">
      {options.map((option) => (
        <button
          key={option.code}
          type="button"
          onClick={() => definirSite(option.code)}
          aria-pressed={site === option.code}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
            site === option.code
              ? 'bg-codialis-navy text-white'
              : 'text-codialis-gray hover:bg-gray-50'
          }`}
        >
          {option.libelle}
        </button>
      ))}
    </div>
  );
}
